export default __webpack_public_path__ + "static/media/3_4.45dbc710.png";